import React, { createContext, useContext, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { applyPublicMetadata, tightenMetadataForLocation } from '../utils/publicMetadata.js';

const MetadataCollector = createContext(null);

// Each server render supplies its own collector. No metadata is retained between
// requests; later page-specific metadata supersedes the route defaults.
export function PublicMetadataProvider({ collect, children }) {
  return <MetadataCollector.Provider value={collect}>{children}</MetadataCollector.Provider>;
}

export function usePublicMetadata(factory, dependencies) {
  const collect = useContext(MetadataCollector);
  const { pathname, search } = useLocation();
  // Callers declare the inputs of their pure metadata factory at the call site.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const pageMetadata = useMemo(factory, dependencies);
  const metadata = useMemo(() => tightenMetadataForLocation(pageMetadata, { pathname, search }), [pageMetadata, pathname, search]);
  if (collect && metadata) collect(metadata);
  useEffect(() => {
    if (metadata) applyPublicMetadata(metadata);
  }, [metadata]);
  return metadata;
}
